"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToastContainerContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useToastContainerContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useToastContainerContextValues_unstable(state) {
    const { close, intent, titleId, bodyId } = state;
    const toastContainerContext = _react.useMemo(()=>({
            close,
            intent,
            titleId,
            bodyId
        }), [
        close,
        intent,
        titleId,
        bodyId
    ]);
    return {
        toast: toastContainerContext
    };
}
